import { Box, Divider, Typography, useTheme } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as dayjs from "dayjs";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { useStyle } from "./styles";
import { useOutletContext } from "react-router-dom";

interface IntervaloColetaProps {
  intervalData: {
    dataInicial: dayjs.Dayjs;
    dataFinal: dayjs.Dayjs;
  };
  setIntervalData: React.Dispatch<
    React.SetStateAction<{
      dataInicial: dayjs.Dayjs;
      dataFinal: dayjs.Dayjs;
    }>
  >;
}
interface OutletContextType {
  config: EasyReportConfig[];
  setConfig: React.Dispatch<React.SetStateAction<EasyReportConfig[]>>;
}

export const IntervaloColeta: React.FC<IntervaloColetaProps> = ({
  intervalData,
  setIntervalData,
}) => {
  const theme = useTheme();
  const styles = useStyle(theme);
  const [timeLimit, setTimeLimit] = useState(2);
  const [errorInitialDate, setErrorInitialDate] = useState<string | null>(null);
  const [errorEndDate, setErrorEndDate] = useState<string | null>(null);

  const { config } = useOutletContext<OutletContextType>();

  useEffect(() => {
    const intervalConfig = config.find((c) => c.nome === "geral")?.configuracoes
      ?.interval;
    setTimeLimit(intervalConfig || 2);
  }, [config]);

  const isSameDate = dayjs(intervalData.dataInicial).isSame(
    dayjs(intervalData.dataFinal),
  );
  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography sx={styles.title}>{"Intervalo de Coleta"}</Typography>
        <Typography sx={styles.subtitle}>
          {"Atribua um título, adicione os host e seus respectivos itens"}
        </Typography>
      </Box>
      <Divider />
      <Box sx={styles.boxIntervalo}>
        <Box sx={styles.boxInput}>
          <Typography sx={styles.titleInput}>{"Data Inicial"}</Typography>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={"pt-br"}
          >
            <DateTimePicker
              value={dayjs(intervalData.dataInicial)}
              onChange={(newValew: dayjs.Dayjs | null) => {
                if (newValew)
                  setIntervalData((prev) => ({
                    ...prev,
                    dataInicial: dayjs(newValew),
                  }));
              }}
              onError={(newError) => setErrorInitialDate(newError)}
              slotProps={{
                textField: {
                  size: "small",
                  error: !!(
                    errorEndDate === "minDate" ||
                    isSameDate ||
                    errorInitialDate
                  ),
                  helperText: errorInitialDate
                    ? `A data inicial não pode ser anterior a ${timeLimit} meses atrás`
                    : errorEndDate === "minDate"
                      ? "A Data Final não pode ser inferior à Data Inicial"
                      : isSameDate
                        ? "A data final não pode ser igual à inicial"
                        : "",
                },
              }}
              minDate={dayjs(Date.now()).subtract(timeLimit, "month")}
              maxDate={
                intervalData.dataFinal &&
                intervalData.dataFinal.isBefore(
                  dayjs(Date.now()).startOf("day"),
                )
                  ? intervalData.dataFinal
                  : dayjs(Date.now()).startOf("day")
              }
            />
          </LocalizationProvider>
        </Box>
        <Box sx={styles.boxInput}>
          <Typography sx={styles.titleInput}>{"Data Final"}</Typography>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={"pt-br"}
          >
            <DateTimePicker
              value={dayjs(intervalData.dataFinal)}
              onChange={(newValeu: dayjs.Dayjs | null) => {
                if (newValeu)
                  setIntervalData((prev) => ({
                    ...prev,
                    dataFinal: dayjs(newValeu),
                  }));
              }}
              onError={(newError) => setErrorEndDate(newError)}
              slotProps={{
                textField: {
                  size: "small",
                  helperText:
                    errorEndDate === "minDate"
                      ? "A Data Final não pode ser inferior a Data Inicial"
                      : "",
                },
              }}
              minDate={
                intervalData.dataInicial &&
                intervalData.dataInicial.isAfter(
                  dayjs(Date.now()).subtract(timeLimit, "month"),
                )
                  ? intervalData.dataInicial
                  : dayjs(Date.now()).subtract(timeLimit, "month")
              }
              maxDate={dayjs(Date.now()).startOf("day")}
            />
          </LocalizationProvider>
        </Box>
      </Box>
    </Box>
  );
};
